import { useEffect, useState } from "react";
import ActivityCard from "../../../Components/ActivityCard/ActivityCard";
import { useDispatch, useSelector } from "react-redux";
import { galleryStudentList, getStudentGallery, setFilters } from "../../../redux/actions/dashboard";
import Filters from "../Components/Filters";
import { GALLERY_FILTER } from "../../../redux/actions/types";
import Pagination from "react-js-pagination";
import { galleryActiveFilter } from "../../../helper/general";

const Gallery = () => {
  const dispatch = useDispatch();

  const gallery = useSelector(state => state.dashboard.studentGallery);
  const galleryFilter = useSelector(state => state.dashboard.galleryFilter);
  const studentList = useSelector(state => state.dashboard.galleryStudentList);

  const [reload, setReload] = useState(0);
  const [activePage, setActivePage] = useState(1);

  var studentNameList = studentList?.data?.reduce((obj, item) => Object.assign(obj, { [item.id]: item.name }), {});
  const additionalFilter = { "Student Name": { ...studentNameList } }

  useEffect(() => {
    dispatch(getStudentGallery({ ...galleryFilter, pageNo: (activePage - 1), pageSize: 10 }))
  }, [reload]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const data = { ...galleryFilter };
    const index = data[name]?.indexOf(parseInt(value));
    if (index >= 0) {
      data[name].splice(index, 1);
    } else {
      data[name].push(parseInt(value));
    }
    dispatch(setFilters(GALLERY_FILTER, data));
    setReload(Math.random());
  };

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1;
    setActivePage(pageNumber);
    dispatch(getStudentGallery({ ...galleryFilter, pageNo: page, pageSize: 10 }))
  }

  const handleStudentSearch = e => {
    const { name, value } = e.target;
    if (galleryFilter?.kidIds?.length) {
      dispatch(setFilters(GALLERY_FILTER, { ...galleryFilter, kidIds: [] }));
      const currentFilter = { ...galleryFilter, kidIds: [] }
      dispatch(getStudentGallery({ ...currentFilter, pageNo: 0, pageSize: 10 }));
    }
    if (value.length > 2) {
      dispatch(galleryStudentList({ ...galleryFilter, nameLike: value, pageNo: 0, pageSize: 100 }));
    }
  }

  return (
    <div className="container divider">
      <Filters handleFilterChange={handleFilterChange} filterData={galleryFilter} activeFilter={galleryActiveFilter} additionalFilter={additionalFilter} additionMethod={handleStudentSearch} />
      <div className="image-gallery px-2">
        <div className="row justify-content-between">
          {gallery?.data?.map((item, index) => (
            <div className="col-12 col-sm-10 col-md-6  mx-auto" key={index}>
              <ActivityCard data={item} id={index} />
            </div>
          ))}
        </div>
        {gallery?.pagination_info && gallery?.pagination_info?.total_elements > 0 &&
          <div className="pagination-bar w-100 d-flex justify-content-between border-top-0">
            <p className="counting mb-0">{activePage} out of {gallery?.pagination_info?.total_pages}</p>
            <nav aria-label="Page navigation example">
              <Pagination
                activePage={activePage}
                itemsCountPerPage={gallery?.pagination_info?.page_size}
                totalItemsCount={gallery?.pagination_info?.total_elements}
                pageRangeDisplayed={5}
                innerClass="pagination mb-0 p-0"
                itemClass="page-item"
                linkClass="page-link"
                onChange={handlePageChange}
              />
            </nav>
          </div>
        }
      </div>
    </div>
  );
};

export default Gallery;
